import { render } from "./2drawer.vue?vue&type=template&id=5b5b8ee8&lang=pug"
import script from "./2drawer.vue?vue&type=script&lang=js"
export * from "./2drawer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/json/Code/chekt/app/fty/hosting/console/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QList,QItemLabel,QItem,QItemSection,QIcon,QTooltip});
